/*
 * @Author: edvardchen
 * @Date:   2016-11-13 19:29:03
 * @Last Modified by: qiyuanchen
 * @Last Modified time: 2020-01-15 17:47:00
 */
// @flow
import _ from 'lodash';
import Url from 'url';
import { connect } from 'react-redux';
import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import Banner from 'uistyles/comby/banner';

import { removeDBBar } from '../../actions/installer';
import { loadDownloadScene } from '../../actions/sharepage';
import { refreshRMP, getShareURlDocId } from '../../utility/ClipperForRMP';
import isFeedsFast from '../../utility/isFeedsFast';
import { isLoadKuaiBao, getBarStyleValue, getProfileId } from '../../utility/PageConfigDataForShare';

import { track, isQQ, isAndroid, listenToScroll, isTBS } from '../../utility';
import { loadStatus, download, install, openQb, cancelQbDownLoadForShare } from '../../utility/QBDownload';
import Bar from './BarForShare';
type Props = {
  url: string,
  DBBarRemoved: boolean,
  dispatch: Function,
  status: number,
  SlideBanner: boolean,
  list: Array,
  exposureSharelp: Object,
  downLoadStatus: string,
  progressValue: string,
  loadingText: string,
  bannerClass: string,
};
const reachBottom = () => window.pageYOffset + window.innerHeight > document.body.offsetHeight - 10;
class DownloadBar extends React.PureComponent<Props> {
  currentSlideIndex: 0;
  prevY: 0;
  nextY: 0;
  monitorTimmer: null;
  static defaultProps = {
    show: true,
  };

  static shareLabel = 'DownloadBar';

  constructor(props) {
    super(props);
    this.state = {
      showBanner: true,
    };
  }
  componentDidMount() {
    const { userAgent } = window.navigator;
    if (isQQ(userAgent) && isAndroid(userAgent)) {
      // QQ TBS 内嵌拉新，因此隐藏我们业务自有的下载bar
      // setTimeout(() => {
      //   this.props.dispatch(removeDBBar());
      // });
    }
    this.scrollWatch = listenToScroll(() => {
      this.monitorTimmer && clearTimeout(this.monitorTimmer);
      this.prevY = !this.prevY ? 0 : this.prevY;
      this.nextY = window.pageYOffset;
      if (this.prevY < this.nextY) {
        this.monitorShowBanner();
        this.state.showBanner && this.setState({ showBanner: false });
      } else if (this.prevY >= this.nextY) {
        !this.state.showBanner && this.setState({ showBanner: true });
      }
      if (reachBottom()) {
        !this.state.showBanner && this.setState({ showBanner: true });
      }
      this.prevY = this.nextY;
    });
  }
  componentWillUnmount() {
    this.scrollWatch && this.scrollWatch.remove();
  }

  monitorShowBanner = () => {
    this.monitorTimmer = setTimeout(() => {
      !this.state.showBanner && this.setState({ showBanner: true });
    }, 2000);
  };

  @autobind
  onIndicatorCLick() {
    const { status } = this.props;
    let openUrl = this.props.url;
    this.props.dispatch(loadDownloadScene('bar')); // 点击推荐文章底部按钮，标志来源：底部bar
    if (this.props.SlideBanner && this.props.list && this.props.list instanceof Array && this.props.list.length > 0) {
      const index = !this.currentSlideIndex ? 0 : this.currentSlideIndex;
      openUrl = this.props.list[index].url;
      track({
        location: 'sharelp',
        action: 'click',
        object: `sharelp_bar${index + 1}`,
        id: this.props.exposureSharelp && this.props.exposureSharelp.docId,
        ch: getProfileId() || (this.props.exposureSharelp && this.props.exposureSharelp.ch),
      });
    }
    // 点击底部Bar写入当前文章docId
    refreshRMP(getShareURlDocId(openUrl));
    // 防止参数加不上
    const { host, query } = Url.parse(openUrl, true);
    if (host === 'news.html5.qq.com') {
      const stuff = _.isEmpty(query) ? '' : '&';
      openUrl += `${stuff}cardmode=1`;
    }

    // 下载逻辑区分是否支持Android与tbs
    if (isAndroid(window.navigator.userAgent) && isTBS(window.navigator.userAgent) && !isFeedsFast()) {
      download({
        label: DownloadBar.shareLabel,
        dispatchFunc: this.props.dispatch,
        url: openUrl,
      });
    } else {
      switch (status) {
        case loadStatus.INSTALLED: {
          openQb({
            url: openUrl,
            label: DownloadBar.shareLabel,
          });
          break;
        }
        case loadStatus.LOADED:
          install();
          break;
        case loadStatus.LOADING:
          // do nothing
          // 不支持取消或者暂停
          return;
        default:
          download({
            label: DownloadBar.shareLabel,
            dispatchFunc: this.props.dispatch,
            url: openUrl,
          });
      }
    }
  }

  @autobind
  onClose(event) {
    event.stopPropagation();
    if (this.props.exposureSharelp) {
      track({
        location: 'sharelp',
        action: 'click',
        object: 'sharelp_barclose',
        id: this.props.exposureSharelp && this.props.exposureSharelp.docId,
        ch: this.props.exposureSharelp && this.props.exposureSharelp.ch,
      });
    } else {
      track({
        location: 'share',
        action: 'close',
        object: 'download_bar',
      });
    }
    this.props.dispatch(removeDBBar());
  }
  // 暂停,重启下载下载
  @autobind
  cancelDownload(event) {
    event.stopPropagation();
    if (this.props.downLoadStatus === 'downloading') {
      cancelQbDownLoadForShare(this.props.dispatch);
    } else {
      // 暂停后重启不需要传入url。直接取本地缓存的url
      download({
        dispatchFunc: this.props.dispatch,
      });
    }
  }
  @autobind
  beforeChangeHandler(oldIndex, newIndex) {
    this.currentSlideIndex = newIndex;
  }

  render() {
    const { downLoadStatus, loadingText, bannerClass, progressValue } = this.props;

    if (this.props.DBBarRemoved) {
      return null;
    }
    const isFF = isFeedsFast();
    const isKuaibao = isLoadKuaiBao();

    // 命中profile的bar样式
    let classValue = '';
    const barStyleValue = isKuaibao ? getBarStyleValue() : '';
    if (barStyleValue) {
      classValue = `share-bottom-tips-wrap-new-${barStyleValue}`;
    }

    if (this.props.SlideBanner && this.props.list && this.props.list instanceof Array && this.props.list.length > 0) {
      return (
        <div
          className={`share-bottom-tips-wrap share-bottom-tips-wrap-new ${classValue} on-animation ${bannerClass} ${
            isFF || isKuaibao ? 'is-kb_sharelp_banner' : ''
          }`}
        >
          <Banner autoplay className={'share-bottom-tips'} beforeChange={this.beforeChangeHandler}>
            {this.props.list.map((item, key) => {
              const retItem = (
                <Bar
                  {...item}
                  {...this.props}
                  key={key}
                  onCLose={this.onClose}
                  onIndicatorCLick={this.onIndicatorCLick}
                />
              );
              return retItem;
            })}
          </Banner>
          {(downLoadStatus === 'downloading' || downLoadStatus === 'downloadcanceled') && (
            <div className="share-bottom-bar" onClick={this.cancelDownload}>
              <div className="share-bottom-progress" style={{ width: progressValue }}></div>
              <span className="share-progress-text">{loadingText}</span>
              <span className="share-progress-value">{progressValue}</span>
            </div>
          )}
        </div>
      );
    }
    return null;
  }
}

export default connect(
  ({
    installer: { installStatus: status, donwloadPercent: percent, DBBarShown: show, DBBarRemoved },
    sharepage: { downLoadStatus, progressValue, loadingText, bannerClass },
  }) => ({
    status,
    percent,
    show,
    DBBarRemoved,
    downLoadStatus,
    progressValue,
    loadingText,
    bannerClass,
  }),
)(DownloadBar);
